import React from 'react'
import { useNavigate } from 'react-router-dom';
import leftArrow from '../../assets/images/left-arrow.svg';


const BackButton = () => {

    const navigate = useNavigate();

    return (
        <button role="button" title="Back" onClick={() => navigate(-1)} className="back-arrow btn">
            <img src={leftArrow} />
        </button>
    )
}

export default BackButton
